import Blue from '~/core'

new Blue({
  name: 'Hero Video',
  selector: '.hero--landing',
  setup(hero) {
    const heroVideo = hero.querySelector('.hero__media video')
    if (heroVideo) {
      heroVideo.play()
    }
  },
})
